"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c, _d, _e, _f;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelSelect = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const backendImport_1 = require("@front/backendImport");
const client_1 = require("@rws-framework/client");
const events_1 = require("../form-parts/events");
const models_types_1 = require("../../types/models.types");
//@ts-ignore                
let rwsTemplate = T.html `<div id="model-selector">
    ${(0, fast_element_1.when)(x => x.training === 'false', (0, fast_element_1.html) `<div class="main-provider-choice">
        <strong>${'ai.models.source'.t()}:</strong>
        <the-form>
            <part-radio 
                value="${x => x.aiProvider}" 
                name="ai-provider" 
                class="static inline" 
                :options="${x => x.aiProviderChoices}"
            ></part-radio>
        </the-form>
    </div>`)}
    ${(0, fast_element_1.when)(x => x.aiProvider !== 'inthub', (0, fast_element_1.html) `<div class="model-select-wrapper">
        <v-select 
        value="${x => { var _a; return (_a = x.selectedProvider) === null || _a === void 0 ? void 0 : _a.value; }}" 
            @change="${(x, c) => x.chooseProvider(c.event)}" 
            @focus="${x => x.onSelectOpen()}"
            @blur="${x => x.onSelectClose()}"
            placeholder="${'ai.com.choose_provider'.t()}" 
            :choiceList="${x => [{ value: null, label: 'ai.com.choose_provider'.t() }, ...x.providersList]}"
        ></v-select>       

        ${(0, fast_element_1.when)(x => x.selectedProvider, (0, fast_element_1.html) `<v-select 
                value="${x => { var _a; return (_a = x.selectedModel) === null || _a === void 0 ? void 0 : _a.value; }}" 
                @change="${(x, c) => x.chooseModel(c.event)}" 
                @focus="${x => x.onSelectOpen()}"
                @blur="${x => x.onSelectClose()}"
                placeholder="${'ai.com.choose_model'.t()}" 
                :choiceList="${x => { var _a; return [{ value: null, label: 'ai.com.choose_model'.t() }, ...(_a = x.selectedProvider) === null || _a === void 0 ? void 0 : _a.models] || []; }}"
            ></v-select>
        `)}       
    </div>`)}  
    ${(0, fast_element_1.when)(x => x.aiProvider === 'inthub', (0, fast_element_1.html) `<div class="model-select-wrapper">
        <v-select 
            value="${x => { var _a; return (_a = x.selectedAvatar) === null || _a === void 0 ? void 0 : _a.id; }}" 
            @change="${(x, c) => x.chooseAvatar(c.event)}" 
            @focus="${x => x.onSelectOpen()}"
            @blur="${x => x.onSelectClose()}"
            placeholder="${'ai.com.choose_avatar'.t()}" 
            :choiceList="${x => [{ value: null, label: 'ai.com.choose_avatar'.t() }, ...x.avatars.map(a => ({ value: a.id, label: a.name }))]}"
        ></v-select>    
    </div>`)}
</div>`;
require("./styles/layout.scss");
const styles = T.css `:host(.select-open) {
  z-index: 101 !important;
}

#model-selector .main-provider-choice {
  display: flex;
  gap: 15px;
}
#model-selector .model-select-wrapper {
  display: flex;
  gap: 15px;
}`;
const shadowOptions = { "mode": "open" };
let ModelSelect = class ModelSelect extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.modelsChoices = [];
        this.avatars = [];
        this.providers = new Map();
        this.providersList = [];
        this.isSelectOpen = false;
        this.aiProviderChoices = [{ label: 'OpenRouter', value: 'openrouter' }, { label: 'Together AI', value: 'together' }];
        this.training = 'false';
        this.noAvatar = 'false';
    }
    async connectedCallback() {
        super.connectedCallback();
        if (!this.aiProvider) {
            this.aiProvider = 'openrouter';
        }
        if (this.noAvatar === 'false') {
            this.aiProviderChoices = [...this.aiProviderChoices, { label: 'Avatars', value: 'inthub' }];
        }
        await this.initList();
        this.on(events_1.inputEvents.changed, (event) => {
            this.aiProvider = event.detail.element.value;
            if (this.onChange) {
                this.selectedModel = null;
                this.selectedProvider = null;
                this.selectedAvatar = null;
                this.onChange({
                    provider: null,
                    model: null,
                    aiProvider: this.aiProvider
                });
            }
            this.initList();
        });
    }
    async initList() {
        if (this.training === 'true') {
            this.aiProvider = 'together';
            for (const prov of backendImport_1.trainingProviders) {
                for (const model of prov.models) {
                    this.addProvider(prov.name, prov.value, model);
                }
            }
            this.providersChoiceList();
            return;
        }
        if (!this.aiProvider) {
            return;
        }
        if (this.aiProvider !== 'inthub') {
            this.modelsChoices = (await this.apiService.back.get('ai.model-list', { routeParams: { provider: this.aiProvider } })).data;
        }
        else {
            this.avatars = (await this.apiService.back.get('avatar.list')).data.filter(a => a.model && a.model.model && a.model.model.value);
        }
        this.sortProviders();
        this.processValue();
    }
    mainProviderChanged(oldVal, newValue) {
        if (newValue) {
            this.aiProvider = newValue;
            this.initList();
        }
    }
    processValue() {
        this.selectedModel = null;
        this.selectedProvider = null;
        if (this.aiProvider === 'inthub' && this.value) {
            const avatar = this.avatars.find(a => a.id === this.value);
            if (avatar) {
                this.selectedAvatar = avatar;
                this.selectedModel = avatar.model.model;
                this.selectedProvider = avatar.model.provider;
            }
            return;
        }
        for (const provider of this.providers.values()) {
            for (const model of provider.models) {
                if (model.value === this.value) {
                    this.selectedProvider = provider;
                    this.selectedModel = provider.models.find(item => item.value === this.value);
                    return;
                }
            }
        }
    }
    chooseAvatar(e) {
        const avatarId = e.target.value;
        this.selectedAvatar = this.avatars.find(a => a.id === avatarId);
        if (this.selectedAvatar) {
            this.selectedModel = this.selectedAvatar.model.model;
            this.selectedProvider = this.selectedAvatar.model.provider;
            this.onChange({
                provider: this.selectedProvider,
                model: this.selectedModel,
                aiProvider: this.aiProvider,
                avatar: avatarId,
                avatarProvider: this.selectedAvatar.model.aiProvider
            });
        }
        else {
            this.onChange(null);
        }
    }
    sortProviders() {
        this.providers = new Map();
        for (const item of this.modelsChoices) {
            const providerName = item.label.split(':')[0];
            const providerVal = item.value.split('/')[0];
            this.addProvider(providerName, providerVal, item);
        }
        this.providersChoiceList();
    }
    addProvider(providerName, providerVal, model) {
        const modelName = model.label.split(':').pop().trim();
        if (!this.providers.has(providerVal)) {
            this.providers.set(providerVal, {
                name: providerName,
                value: providerVal,
                models: [
                    {
                        label: modelName,
                        value: model.value,
                        description: model.description
                    }
                ]
            });
        }
        else {
            if (this.providers.get(providerVal).models.find(m => m.value === model.value)) {
                return;
            }
            this.providers.get(providerVal).models.push({ label: modelName, value: model.value, description: model.description });
        }
    }
    providersChoiceList() {
        this.providersList = Array.from(this.providers).map(item => ({ label: item[1].name, value: item[1].value }));
    }
    chooseProvider(e) {
        const providerValue = e.target.value;
        this.selectedProvider = this.providers.get(providerValue);
        this.selectedModel = null;
        this.selectedAvatar = null;
        this.onChange({
            provider: this.selectedProvider,
            model: null,
            aiProvider: this.aiProvider
        });
    }
    chooseModel(e) {
        const modelVal = e.target.value;
        this.selectedModel = this.selectedProvider.models.find(item => item.value === modelVal);
        this.selectedAvatar = null;
    }
    selectedModelChanged(oldVal, newValue) {
        if (newValue && this.onChange && this.aiProvider !== 'inthub') {
            // console.log('modelstart', { newValue, oldVal });
            this.onChange({
                provider: this.selectedProvider,
                model: newValue,
                aiProvider: this.aiProvider,
                // avatar: this.selectedAvatar ? this.selectedAvatar.id as string : null,
            });
        }
    }
    onSelectOpen() {
        this.isSelectOpen = true;
        this.getShadowRoot().host.classList.add('select-open');
    }
    onSelectClose() {
        this.isSelectOpen = false;
        this.getShadowRoot().host.classList.remove('select-open');
    }
    onChange(selected) {
        const ev = new CustomEvent('model:selected', {
            detail: selected,
            bubbles: true,
            composed: true
        });
        this.dispatchEvent(ev);
    }
};
exports.ModelSelect = ModelSelect;
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], ModelSelect.prototype, "avatars", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], ModelSelect.prototype, "providersList", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_a = typeof backendImport_1.IProvider !== "undefined" && backendImport_1.IProvider) === "function" ? _a : Object)
], ModelSelect.prototype, "selectedProvider", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_b = typeof backendImport_1.IProvidedModel !== "undefined" && backendImport_1.IProvidedModel) === "function" ? _b : Object)
], ModelSelect.prototype, "selectedModel", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_c = typeof backendImport_1.IAvatar !== "undefined" && backendImport_1.IAvatar) === "function" ? _c : Object)
], ModelSelect.prototype, "selectedAvatar", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], ModelSelect.prototype, "isSelectOpen", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", typeof (_d = typeof models_types_1.AIProviderFrontType !== "undefined" && models_types_1.AIProviderFrontType) === "function" ? _d : Object)
], ModelSelect.prototype, "mainProvider", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_e = typeof models_types_1.AIProviderFrontType !== "undefined" && models_types_1.AIProviderFrontType) === "function" ? _e : Object)
], ModelSelect.prototype, "aiProvider", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_f = typeof Array !== "undefined" && Array) === "function" ? _f : Object)
], ModelSelect.prototype, "aiProviderChoices", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], ModelSelect.prototype, "value", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], ModelSelect.prototype, "training", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], ModelSelect.prototype, "noAvatar", void 0);
exports.ModelSelect = ModelSelect = __decorate([
    (0, client_1.RWSView)('model-select', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], ModelSelect);
ModelSelect.defineComponent();
